import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34766375"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-course-id", "data-page-id", "data-part-id", "data-exposure-time"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "attachment"
}
const _hoisted_5 = ["href"]

import {ref} from 'vue'
import {PageRecord} from "@/models/page/pageRecord";
import {contentRender} from "@/lib/contentRender";
import Program from "@/models/page/program";
import {Download as DownloadIcon} from "@element-plus/icons"


// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'ProgramPage',
  props: {
    page: {},
    userPage: {},
    courseId: {},
    partId: {},
    pageId: {}
  },
  setup(__props: any) {

const props = __props

const showTitle = ref(false) // 默认不显示标题

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "exposure program-page",
    "data-course-id": _ctx.courseId,
    "data-page-id": _ctx.pageId,
    "data-part-id": _ctx.partId,
    "data-exposure-time": _ctx.userPage.exposureTime
  }, [
    (showTitle.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "title",
          innerHTML: _unref(contentRender)(_ctx.page.programName)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "contents-desc",
      innerHTML: _unref(contentRender)(_ctx.page.programDesc)
    }, null, 8, _hoisted_3),
    (_ctx.page.attachmentUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(DownloadIcon), { class: "icon" }),
          _createElementVNode("a", {
            href: _ctx.page.attachmentUrl
          }, _toDisplayString(_ctx.page.attachmentName), 9, _hoisted_5)
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})